import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { message } from 'antd';
import { useCookies } from 'react-cookie';
import { theme } from 'utils/style/theme';
import { adCompensationApis } from 'apis/operation/adCompensationApis';
import { fetchCurrencyListApi } from 'apis/common/commonApis';
import DefaultLayout from 'components/layout/DefaultLayout';
import GrayBox from 'components/container/GrayBox';
import TableToolbar from 'components/table/TableToolbar';
import RegisterButton from 'components/button/RegisterButton';
import VerticalTable from 'components/table/VerticalTable';
import ToggleButton from 'components/button/ToggleButton';
import DefaultInput from 'components/input/DefaultInput';
import DefaultSelect from 'components/select/DefaultSelect';
import TextGrayBox from 'components/etc/TextGrayBox';

/**
 *
 * @returns {판매 - 광고 보상 관리}
 */
const AdCompensationPage = () => {
  const [cookies] = useCookies();
  const authUpdate = JSON.parse(cookies?.managementAuth);
  const [currencyDropList, setCurrencyDropList] = useState();
  const [missionInputData, setMissionInputData] = useState();
  const [timeInputData, setTimeInputData] = useState();

  //* 미션 보상 => 인풋-토글 */
  const handleMissionInputChange = (e) => {
    const { name, value, checked } = e.target;
    if (name === 'is_public') {
      setMissionInputData({
        ...missionInputData,
        [name]: checked === true ? 1 : 0,
      });
    } else {
      setMissionInputData({ ...missionInputData, [name]: value });
    }
  };
  //* 미션 셀렉박스 데이터 */
  const handleMissionSelect = (val, obj) => {
    setMissionInputData({ ...missionInputData, [obj.name]: val });
  };

  //* 시간 보상 => 인풋-토글 */
  const handleTimeInputChange = (e) => {
    const { name, value, checked } = e.target;
    if (name === 'is_public') {
      setTimeInputData({ ...timeInputData, [name]: checked === true ? 1 : 0 });
    } else {
      setTimeInputData({ ...timeInputData, [name]: value });
    }
  };
  //* 시간 셀렉박스 데이터 */
  const handleTimeSelect = (val, obj) => {
    setTimeInputData({ ...timeInputData, [obj.name]: val });
  };

  //* 서버 저장 */
  const handleSubmit = async () => {
    let rows = [missionInputData, timeInputData];
    // console.log(rows);

    const res = await adCompensationApis.update(rows);
    // console.log(res);
    if (!res) {
      return false;
    }
    fetchData();
    message.success('광고 보상 설정이 수정되었습니다. ', 1);
  };
  //* 배포하기 */
  const handleDeploy = async () => {
    '';
  };
  const fetchData = async () => {
    const res = await adCompensationApis.read();
    setMissionInputData(res[0]);
    setTimeInputData(res[1]);
  };
  const fetchDropData = async (e) => {
    const resCurrency = await fetchCurrencyListApi(e ? e.target.value : '');
    setCurrencyDropList(resCurrency);
  };
  useEffect(() => {
    fetchData().catch(console.log);
    fetchDropData().catch(console.log);
  }, []);
  return (
    <DefaultLayout>
      <TableToolbar>
        <div></div>
        <div>
          <RegisterButton onClick={handleSubmit} disabled={authUpdate}>
            저장하기
          </RegisterButton>
          <RegisterButton onClick={handleDeploy} disabled={true}>
            배포하기
          </RegisterButton>
        </div>
      </TableToolbar>
      <GrayBox layout>
        <ContentWrap>
          <h3>미션 광고 보상</h3>
          <div className='toggle_wrap'>
            <p>활성화</p>
            <ToggleButton
              name='is_public'
              onChange={handleMissionInputChange}
              checked={missionInputData?.is_public === 0 ? false : true}
            />
          </div>

          <VerticalTable className='ad_table2'>
            <>
              <tr>
                <th>타이틀(로컬 ID)</th>
                <td colSpan={5}>
                  <TextWrap>
                    <DefaultInput
                      name='name'
                      type='number'
                      style={{ width: '10rem' }}
                      value={missionInputData?.name}
                      onChange={handleMissionInputChange}
                    />
                    <TextGrayBox>{missionInputData?.name_text}</TextGrayBox>
                  </TextWrap>
                </td>
              </tr>
              <tr className='th_color'>
                <th>1단계</th>
                <td></td>
                <th>2단계</th>
                <td></td>
                <th>3단계</th>
                <td></td>
              </tr>
              <tr>
                <th>달성 횟수</th>
                <td>
                  <DefaultInput
                    name='first_count'
                    type='number'
                    value={missionInputData?.first_count}
                    onChange={handleMissionInputChange}
                    style={{ width: '10rem' }}
                  />
                </td>
                <th>달성 횟수</th>
                <td>
                  <DefaultInput
                    name='second_count'
                    type='number'
                    value={missionInputData?.second_count}
                    onChange={handleMissionInputChange}
                    style={{ width: '10rem' }}
                  />
                </td>
                <th>달성 횟수</th>
                <td>
                  <DefaultInput
                    name='third_count'
                    type='number'
                    value={missionInputData?.third_count}
                    onChange={handleMissionInputChange}
                    style={{ width: '10rem' }}
                  />
                </td>
              </tr>
              <tr>
                <th>보상</th>
                <td>
                  <DefaultSelect
                    name='first_currency'
                    optionList={currencyDropList}
                    value={missionInputData?.first_currency}
                    onChange={handleMissionSelect}
                    onKeyUp={fetchDropData}
                    filterOption={false}
                    style={{ width: '10rem' }}
                    showSearch
                  />
                </td>
                <th>보상</th>
                <td>
                  <DefaultSelect
                    name='second_currency'
                    optionList={currencyDropList}
                    value={missionInputData?.second_currency}
                    onChange={handleMissionSelect}
                    onKeyUp={fetchDropData}
                    filterOption={false}
                    style={{ width: '10rem' }}
                    showSearch
                  />
                </td>
                <th>보상</th>
                <td>
                  <DefaultSelect
                    name='third_currency'
                    optionList={currencyDropList}
                    value={missionInputData?.third_currency}
                    onChange={handleMissionSelect}
                    onKeyUp={fetchDropData}
                    filterOption={false}
                    style={{ width: '10rem' }}
                    showSearch
                  />
                </td>
              </tr>
              <tr>
                <th>보상 수</th>
                <td>
                  <DefaultInput
                    name='first_quantity'
                    type='number'
                    value={missionInputData?.first_quantity}
                    onChange={handleMissionInputChange}
                    style={{ width: '10rem' }}
                  />
                </td>
                <th>보상 수</th>
                <td>
                  <DefaultInput
                    name='second_quantity'
                    type='number'
                    value={missionInputData?.second_quantity}
                    onChange={handleMissionInputChange}
                    style={{ width: '10rem' }}
                  />
                </td>
                <th>보상 수</th>
                <td>
                  <DefaultInput
                    name='third_quantity'
                    type='number'
                    value={missionInputData?.third_quantity}
                    onChange={handleMissionInputChange}
                    style={{ width: '10rem' }}
                  />
                </td>
              </tr>
            </>
          </VerticalTable>
        </ContentWrap>
      </GrayBox>
      <GrayBox layout>
        <ContentWrap>
          <h3>시간 광고 보상</h3>
          <div className='toggle_wrap'>
            <p>활성화</p>
            <ToggleButton
              name='loading_is_active'
              onChange={handleTimeInputChange}
              checked={timeInputData?.is_public === 1 ? true : false}
            />
          </div>
          <VerticalTable className='ad_table2'>
            <>
              <tr>
                <th>타이틀(로컬 ID)</th>
                <td>
                  <TextWrap>
                    <DefaultInput
                      name='name'
                      type='number'
                      style={{ width: '10rem' }}
                      value={timeInputData?.name}
                      onChange={handleTimeInputChange}
                    />
                    <TextGrayBox>{timeInputData?.name_text}</TextGrayBox>
                  </TextWrap>
                </td>
                <th>보상</th>
                <td>
                  <DefaultSelect
                    name='first_currency'
                    value={timeInputData?.first_currency}
                    optionList={currencyDropList}
                    onChange={handleTimeSelect}
                    onKeyUp={fetchDropData}
                    filterOption={false}
                    style={{ width: '10rem' }}
                    showSearch
                  />
                </td>
              </tr>
              <tr>
                <th>내용(로컬 ID)</th>
                <td>
                  <TextWrap>
                    <DefaultInput
                      name='content'
                      type='number'
                      style={{ width: '10rem' }}
                      value={timeInputData?.content}
                      onChange={handleTimeInputChange}
                    />
                    <TextGrayBox>{timeInputData?.content_text}</TextGrayBox>
                  </TextWrap>
                </td>
                <th>보상 수</th>
                <td>
                  <DefaultInput
                    name='first_quantity'
                    type='number'
                    style={{ width: '10rem' }}
                    value={timeInputData?.first_quantity}
                    onChange={handleTimeInputChange}
                  />
                </td>
              </tr>
              <tr>
                <th>시간 (분)</th>
                <td>
                  <TextWrap>
                    <DefaultInput
                      name='min_time'
                      type='number'
                      style={{ width: '10rem' }}
                      value={timeInputData?.min_time}
                      onChange={handleTimeInputChange}
                    />
                    <div style={{ width: '100%' }}></div>
                  </TextWrap>
                </td>
              </tr>
            </>
          </VerticalTable>
        </ContentWrap>
      </GrayBox>
    </DefaultLayout>
  );
};

export default AdCompensationPage;

const ContentWrap = styled.div`
  display: flex;
  h3 {
    font-weight: 700;
    font-size: 1rem;
    color: ${theme.colors.blueText};
    width: 12rem;
  }
  .toggle_wrap {
    width: 10rem;
    display: flex;
    align-items: flex-start;
    p {
      font-weight: 500;
      margin-right: 0.5rem;
      margin-top: 0.25rem;
    }
  }
`;
const TextWrap = styled.div`
  display: flex;
  align-items: center;
  span {
    /* margin-left: 0.5rem; */
  }
`;
